import { render } from "./modalDetalleOferta.vue?vue&type=template&id=4b2fac92&scoped=true"
import script from "./modalDetalleOferta.vue?vue&type=script&lang=js"
export * from "./modalDetalleOferta.vue?vue&type=script&lang=js"

import "./modalDetalleOferta.vue?vue&type=style&index=0&id=4b2fac92&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2fac92"]])

export default __exports__